import { requisitarJson } from '../../../shared/api/http';

export interface EventoLog {
    id: string;
    em: string;
    fonte: string;
    nivel: 'info' | 'aviso' | 'erro';
    turma_id: string | null;
    mensagem: string;
}

export interface PaginaLog {
    eventos: EventoLog[];
    ate: string | null;
}

export function listarLog({ desde, turmaId }: { desde?: string | null; turmaId?: string | null }): Promise<PaginaLog> {
    const parametros = new URLSearchParams({ limite: desde ? '500' : '200' });
    if (desde) parametros.set('desde', desde);
    if (turmaId) parametros.set('turma_id', turmaId);
    return requisitarJson(`/api/v1/log?${parametros}`);
}
